import { memo } from 'react';

interface SkipLinkProps {
  targetId: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * Skip link component for keyboard navigation accessibility
 * Allows users to skip to main content or other important sections
 */
export const SkipLink = memo(function SkipLink({
  targetId,
  children,
  className = '',
}: SkipLinkProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.focus();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <a href={`#${targetId}`} onClick={handleClick} className={`skip-link ${className}`}>
      {children}
    </a>
  );
});

/**
 * Skip navigation component with common skip links
 */
export const SkipNavigation = memo(function SkipNavigation() {
  return (
    <div className="sr-only focus-within:not-sr-only">
      <SkipLink targetId="main-content">Skip to main content</SkipLink>
      <SkipLink targetId="main-navigation" className="ml-2">
        Skip to navigation
      </SkipLink>
    </div>
  );
});
